import React, {Component} from 'react';
import { inject, observer } from 'mobx-react';

import moment from 'moment';
import { Alert, Select, Upload, Button, Icon, List } from 'antd';
import AirModal from '../../../../../common/components/AirModal';
import AirButton from '../../../../../common/components/AirButton';
import AirInput from "../../../../../common/components/AirInput";
import AirSelectWithLabel from "../../../../../common/components/AirSelectWithLabel";
import './EditOrder.css';

const { Option } = Select;

@inject('translationsStore', 'ordersStore', 'commonStore', 'authStore')
@observer
export default class EditOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      fileList: [],
      files: []
    };
  }

  show = (record) => {
    const { ordersStore } = this.props;
    ordersStore.loadAvailableVehicles();
    this.setState({ visible: true, fileList: [], ...record });
  };

  hide = () => {
    this.setState({
      visible: false,
      carId: undefined,
      externalOfferId: undefined,
      externalOrderId: undefined,
      description: undefined,
      fileList: [],
      files: []
    });
  };

  onVehicleChange = vehicle => {
    this.setState({ carId: vehicle });
  };

  setDescription = e => {
    this.setState({ description: e.target.value });
  };

  onSubmit = () => {
    const { id, carId, externalOfferId, externalOrderId, description, fileList } = this.state;
    const { commonStore, ordersStore } = this.props;

    this.hide();
    commonStore.setLoading(true);
    ordersStore.edit(id, carId, externalOfferId, externalOrderId, description, fileList).then(() => {
      commonStore.setLoading(false);
    });

  }

  uploadFileCreate = file => {
    this.setState(state => ({
      fileList: [...state.fileList, file],
      }));
    return false;
  };
  
  uploadFileRemove = file => {
    const newFileList = [];
    this.state.fileList.forEach(file => {
      if (file.status !== 'removed') {
      newFileList.push(file);
      }
    });
    this.setState(state => ({
    fileList: newFileList
    }));
  };

  acceptOrder = () => {
    const { id } = this.state;
    const { commonStore, ordersStore } = this.props;

    this.hide();
    commonStore.setLoading(true);
    ordersStore.accept(id).then(() => {
      commonStore.setLoading(false);
    });
  }

  declineOrder = () => {
    const { id } = this.state;
    const { commonStore, ordersStore } = this.props;

    this.hide();
    commonStore.setLoading(true);
    ordersStore.decline(id).then(() => {
      commonStore.setLoading(false);
    });
  }

  render() {
    const { translationsStore, commonStore, ordersStore, authStore } = this.props;
    const { visible, carId, externalOfferId, externalOrderId, description, status, acceptedAt, declinedAt, fileList, files } = this.state;

    const availableVehicles = ordersStore.availableVehicles;
    const disabled = !carId;
    const isServiceManager = authStore.isServiceManager;
    const isNotServiceManager = !authStore.isServiceManager;
    const canSave = (status !== "DECLINED" && authStore.isServiceManager);

    return (
      <AirModal
        className="EditOrderModal"
        width="840px"
        visible={visible}
        title={translationsStore.translate('order.editOrder.modal.title')}
        onCancel={this.hide}
        okButton={(canSave ? <AirButton disabled={disabled} size="large" light="true" label={translationsStore.translate('order.editOrder.modal.buttonLabel')} /> : '')}
        onOk={() => !disabled && this.onSubmit()}
      >
        {(status === "ACCEPTED" && (
          <Alert type="success" message={<span>{translationsStore.translate('order.status.ACCEPTED')} {(acceptedAt ? moment(acceptedAt).format(commonStore.longDateFormat.L) : '')}</span>} />
        ))}
        {(status === "DECLINED" && (
          <Alert type="error" message={<span>{translationsStore.translate('order.status.DECLINED')} {(declinedAt ? moment(declinedAt).format(commonStore.longDateFormat.L) : '')}</span>} />
        ))}
        <AirSelectWithLabel
          disabled={true}
          style={{ marginBottom: '10px' }}
          label={translationsStore.translate('order.editOrder.modal.vehicle')}
          onChange={this.onVehicleChange}
          value={carId}
          dropdownMatchSelectWidth={false}
        >
          {availableVehicles.map(vehicle => (
            <Option key={vehicle.key} value={vehicle.key}>
              {vehicle.title} - {vehicle.description}
            </Option>
          ))}
        </AirSelectWithLabel>
        {(status === "ACCEPTED" && (
        <div className="OrderInputRow">
          <AirInput disabled={true} label={translationsStore.translate('order.editOrder.modal.externalOfferId')} value={externalOfferId} onChange={(e) => this.setState({externalOfferId: e.target.value})} />
          {(status === "ACCEPTED" && (
            <AirInput disabled={!isServiceManager} label={translationsStore.translate('order.editOrder.modal.externalOrderId')} value={externalOrderId} onChange={(e) => this.setState({externalOrderId: e.target.value})} />
          ))}
        </div>
        ))}
        {(status !== "ACCEPTED" && (
          <AirInput disabled={status !== "CREATED" || !isServiceManager} label={translationsStore.translate('order.editOrder.modal.externalOfferId')} value={externalOfferId} onChange={(e) => this.setState({externalOfferId: e.target.value})} />
        ))}
        <AirInput label={translationsStore.translate('order.editOrder.modal.description')} 
          textarea
          value={description}
          onChange={this.setDescription}
          maxlength="500"
          autosize={{ minRows: 2, maxRows: 2 }}
          disabled={!isServiceManager}
        />
        {(files !== undefined && files.length > 0) ? 
          <div>
          <strong>{translationsStore.translate('order.editOrder.modal.attachments') + ' (' + files.length + ')'}</strong>
            <List
              className="files-list"
              dataSource={files || []}
              renderItem={file => (
                <li style={{ display: 'inline-block', paddingRight: '10px'}}>
                  <a href={file.file} target="_blank" rel="noopener noreferrer">
                    <Icon type="paper-clip" />
                    {file.fileName}
                  </a>
                </li>
                )}
            >
            </List>
          </div>
					 : "" }
        {(isServiceManager && (
        <Upload
          name="file"
          beforeUpload={this.uploadFileCreate}
          onRemove={this.uploadFileRemove}
          fileList={fileList}
        >
          <Button>
            <Icon type="upload" /> {translationsStore.translate('order.editOrder.modal.upload.placeholder')}
          </Button>
        </Upload>
        ))}
        {(isNotServiceManager && status === "CREATED" && (
          <div className="OrderButtonRow">
            <AirButton
              onClick={() => this.acceptOrder()}
              className="slim" 
              size="large"
              light
              label={translationsStore.translate('order.acceptOrder')}
            />
            <AirButton
              onClick={() => this.declineOrder()}
              className="slim"
              bgcolor={"rgb(253, 87, 87)"}
              size="large"
              light
              label={translationsStore.translate('order.declineOrder')}
            />
          </div>
        ))}
      </AirModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/OrdersTable/EditOrder/EditOrder.js